import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-monitor/instance";

// tbl_rem_instance (reminder cases, written by the engine). Stop is Super Admin only.
const apiReminderInstance = {
  getAll:   (payload) => axiosClient.post(`${BASE}/get-all`, payload),
  getById:  (id)      => axiosClient.get(`${BASE}/get-by-id/${id}`),
  // { ids, reason? } ends OPEN cases.
  stop:     (payload) => axiosClient.put(`${BASE}/stop`, payload),
  // { rule_fid?, fromDate?, toDate? } -> { open_now, by_status, by_rule }
  getStats: (payload) => axiosClient.post(`${BASE}/get-stats`, payload),
};

export default apiReminderInstance;
